import {
    IonToast,
    IonButton,
    IonContent,
    IonButtons,
    IonHeader,
    IonIcon,
    IonPage,
    IonProgressBar,
    IonRefresher,
    IonRefresherContent,
    IonSegment,
    IonSegmentButton,
    IonSpinner,
    IonTitle,
    IonToolbar,
    RefresherEventDetail,
    useIonRouter
} from "@ionic/react";

import {
    arrowBackOutline,
    checkmarkCircleOutline,
    americanFootballOutline,
    lockClosedOutline,
    peopleOutline,
    refreshOutline,
    trophyOutline
} from "ionicons/icons";
import {
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState
} from "react";

import {
    useLocation,
    useParams
} from "react-router-dom";
import {
    FantasyMainTab,
    getFantasyMainTab,
    getFantasyMainTabPath,
    getFantasyPlayersSubmenuPath,
    isFantasyMainTab
} from "../utils/fantasyNavigation";

import {
    getPlayerDetail,
    getPlayersList,
    getTeams,
    Player as PlayerModel,
    Team
} from "../services/mexfbaApi";

import {
    isAuthenticated
} from "../services/auth";

import {
    fantasyApiGet,
    fantasyApiPost
} from "../services/fantasyApi";

import FantasyHeaderActions from "../components/FantasyHeaderActions";

import "./FantasyTopPlayers.css";
import "./FantasyNavigation.css";

import FantasyPlayerModal from "../components/FantasyPlayerModal";

import FantasyTradeOfferModal, {
    FantasyTradeCandidate
} from "../components/FantasyTradeOfferModal";

interface FantasyTopPlayer {
    id: string;
    name: string;
    positionId: string;
    position: string;
    teamId: string;
    teamName: string;
    seasonPoints: number;
    seasonGames: number;
    weekPoints: number;
    recentAverage: number;
    weekProjection: number;
    confidence: string;
    isAvailable: boolean;
    ownerTeamId: string;
    ownerName: string;
    isLocked: boolean;

    image?: string;
}

interface FantasyRosterPlayer {
    id: string;
    name: string;
    positionId: string;
    position: string;
    teamId: string;
    teamName: string;
    slot: string;
    isLocked: boolean;
}

interface FantasyTopPlayersState {
    success: boolean;
    message?: string;

    league: {
        id: string;
        name: string;
    };

    week: {
        realRound: number;
        fantasyRound: number;
        status: string;
    };

    topPlayers: FantasyTopPlayer[];

    roster: {
        players: FantasyRosterPlayer[];
    };
}

function getPositionLabel(
    player: Pick<
        FantasyTopPlayer,
        "position" | "positionId"
    >
): string {
    const position = String(player.position || "")
        .trim()
        .toUpperCase();

    if (position !== "") {
        return position;
    }

    const positions: Record<string, string> = {
        "1": "QB",
        "2": "RB",
        "3": "WR",
        "7": "K",
        "8": "DEF"
    };

    return positions[String(player.positionId || "")] || "—";
}

function formatPoints(value: number): string {
    return Number.isFinite(value)
        ? value.toFixed(1)
        : "0.0";
}

function getPlayerImageUrl(image?: string): string {
    if (!image) {
        return "";
    }

    if (
        image.startsWith("http://") ||
        image.startsWith("https://") ||
        image.startsWith("data:")
    ) {
        return image;
    }

    return `${process.env.PUBLIC_URL || ""}/${image.replace(
        /^(\.\.\/)+/,
        ""
    )}`;
}

function getPlayerInitial(name: string): string {
    return String(name || "J")
        .trim()
        .charAt(0)
        .toUpperCase() || "J";
}

function getWeekStatusLabel(status?: string): string {
    const normalizedStatus = String(status || "")
        .trim()
        .toLowerCase();

    if (normalizedStatus === "live") {
        return "En vivo";
    }

    if (normalizedStatus === "scheduled") {
        return "Próximamente";
    }

    if (normalizedStatus === "final") {
        return "Finalizada";
    }

    return "Sin información";
}

const FantasyTopPlayers: React.FC = () => {
    const router = useIonRouter();
    const { id } = useParams<{ id: string }>();
    const location = useLocation();
const activeMainTab = useMemo<
    FantasyMainTab | undefined
>(
    function (): FantasyMainTab | undefined {
        return getFantasyMainTab(
            location.pathname,
            id
        );
    },
    [id, location.pathname]
);

function navigateMainTab(
    selectedTab: FantasyMainTab
): void {
    if (
        !id ||
        !isFantasyMainTab(selectedTab) ||
        selectedTab === activeMainTab
    ) {
        return;
    }

    const destination = getFantasyMainTabPath(
        selectedTab,
        id
    );

    if (!destination) {
        return;
    }

    router.push(
        destination,
        "none",
        "replace"
    );
}

    const [state, setState] =
        useState<FantasyTopPlayersState | null>(null);

    const [loading, setLoading] = useState(true);
    const [refreshing, setRefreshing] = useState(false);
    const [error, setError] = useState("");
    const [positionFilter, setPositionFilter] =
        useState("all");
    const [
        rankingMode,
        setRankingMode
    ] = useState<"season" | "week">("season");

    const [
        topPlayerImages,
        setTopPlayerImages
    ] = useState<Record<string, string>>({});

    const loadedTopPlayerImagesRef = useRef(
        new Set<string>()
    );

        const [
    selectedPlayerId,
    setSelectedPlayerId
] = useState<string | null>(null);

const [
    tradeRequestedPlayer,
    setTradeRequestedPlayer
] = useState<{
    id: string;
    name: string;
    position: string;
    realTeamName: string;
    ownerName: string;
} | null>(null);

const [
    isTradeOfferOpen,
    setIsTradeOfferOpen
] = useState(false);

const [
    isSubmittingTrade,
    setIsSubmittingTrade
] = useState(false);

const [message, setMessage] = useState("");

const pendingTradePlayerRef = useRef<{
    id: string;
    name: string;
    position: string;
    realTeamName: string;
    ownerName: string;
} | null>(null);

const pendingClaimPlayerIdRef = useRef("");

    const loadTopPlayers = useCallback(
        async function (forceRefresh = false) {
 if (!isAuthenticated()) {
    router.push(
        "/home",
        "root",
        "replace"
    );

    return;
}
            try {
                setError("");

                if (forceRefresh) {
                    setRefreshing(true);
                } else {
                    setLoading(true);
                }

const result = await fantasyApiGet<
    FantasyTopPlayersState
>(
    "control_FantasyPlayersState.php" +
        `?id=${encodeURIComponent(id)}` +
        "&view=leaders" +
        `&t=${Date.now()}`
);

                setState(result);
            } catch (requestError) {
                console.error(
                    "No fue posible cargar líderes Fantasy:",
                    requestError
                );

                setError(
                    requestError instanceof Error
                        ? requestError.message
                        : "No fue posible cargar los líderes Fantasy."
                );
            } finally {
                setLoading(false);
                setRefreshing(false);
            }
        },
        [id, router]
    );

    useEffect(
        function () {
            loadTopPlayers();
        },
        [loadTopPlayers]
    );

    /*
    Actualiza el ranking mientras la jornada tenga actividad.

    live      → cada 30 segundos
    scheduled → cada 5 minutos
    final     → no hace polling automático
*/
useEffect(
    function () {
        if (!state) {
            return;
        }

        const refreshIntervals: Record<
            string,
            number
        > = {
            live: 30000,
            scheduled: 300000
        };

        const refreshInterval =
            refreshIntervals[state.week.status];

        if (!refreshInterval) {
            return;
        }

        const intervalId = window.setInterval(
            function () {
                /*
                    true evita activar el loader principal.
                    Sólo muestra el spinner de actualización.
                */
                loadTopPlayers(true);
            },
            refreshInterval
        );

        return function () {
            window.clearInterval(intervalId);
        };
    },
    [
        state?.week.status,
        loadTopPlayers
    ]
);

    async function handleRefresh(
        event: CustomEvent<RefresherEventDetail>
    ) {
        await loadTopPlayers(true);
        event.detail.complete();
    }

function handleRequestTrade(
    player: {
        id: string;
        name: string;
        position: string;
        realTeamName: string;
        ownerName: string;
    }
): void {
    if (!player.id) {
        setMessage(
            "No fue posible identificar al jugador para el intercambio."
        );

        return;
    }

    /*
        Guarda el jugador temporalmente. El modal de trade se abrirá
        hasta que Ionic confirme que la ficha del jugador ya cerró.
    */
    pendingTradePlayerRef.current = {
        id: player.id,
        name: player.name || "Jugador",
        position: player.position || "—",
        realTeamName:
            player.realTeamName || "Sin equipo",
        ownerName: player.ownerName || ""
    };

    setSelectedPlayerId(null);
}

function handlePlayerModalDismiss(): void {
    setSelectedPlayerId(null);

    const claimPlayerId =
        pendingClaimPlayerIdRef.current;

    /*
        Claim pendiente: la navegación ocurre sólo después de que
        FantasyPlayerModal terminó de cerrarse.
    */
    if (claimPlayerId) {
        pendingClaimPlayerIdRef.current = "";

        window.requestAnimationFrame(function () {
            router.push(
                `/fantasyPlayers/${id}?playerId=${encodeURIComponent(
                    claimPlayerId
                )}`,
                "none",
                "replace"
            );
        });

        return;
    }

    const dropPlayerId = pendingDropPlayerIdRef.current;

if (dropPlayerId) {
    pendingDropPlayerIdRef.current = "";

    window.requestAnimationFrame(function () {
        router.push(
            `/fantasyDropPlayers/${id}?playerId=${encodeURIComponent(
                dropPlayerId
            )}`,
            "none",
            "replace"
        );
    });

    return;
}
    const pendingTradePlayer =
        pendingTradePlayerRef.current;

    if (!pendingTradePlayer) {
        return;
    }

    pendingTradePlayerRef.current = null;

    /*
        Trade pendiente: abre el segundo modal después de retirar el
        overlay de la ficha del jugador.
    */
    window.requestAnimationFrame(function () {
        setTradeRequestedPlayer(pendingTradePlayer);
        setIsTradeOfferOpen(true);
    });
}

async function createTrade(
    offeredPlayerId: string
) {
    if (!tradeRequestedPlayer || isSubmittingTrade) {
        return;
    }

    try {
        setIsSubmittingTrade(true);

const result = await fantasyApiPost<{
    success: boolean;
    message?: string;
}>(
    "control_CreateFantasyTrade.php",
    {
        leagueId: id,
        offeredPlayerId,
        requestedPlayerId:
            tradeRequestedPlayer.id
    }
);

        setIsTradeOfferOpen(false);
        setTradeRequestedPlayer(null);
        setSelectedPlayerId(null);

        setMessage(
            result.message ||
                "Solicitud de intercambio enviada."
        );

        await loadTopPlayers(true);
    } catch (requestError) {
        console.error(
            "No fue posible crear intercambio:",
            requestError
        );

        setMessage(
            requestError instanceof Error
                ? requestError.message
                : "No fue posible enviar la propuesta."
        );
    } finally {
        setIsSubmittingTrade(false);
    }
}

const filteredPlayers = useMemo(
    function (): FantasyTopPlayer[] {
        const players = state?.topPlayers || [];

        const filtered = positionFilter === "all"
            ? players
            : players.filter(function (player) {
                return (
                    getPositionLabel(player) ===
                    positionFilter
                );
            });

        return [...filtered].sort(function (
            left,
            right
        ): number {
            const primaryComparison =
                rankingMode === "season"
                    ? right.seasonPoints - left.seasonPoints
                    : right.weekPoints - left.weekPoints;

            if (primaryComparison !== 0) {
                return primaryComparison;
            }

            /*
                Desempate 1:
                mayor proyección de la jornada.
            */
            const projectionComparison =
                right.weekProjection - left.weekProjection;

            if (projectionComparison !== 0) {
                return projectionComparison;
            }

            /*
                Desempate 2:
                mayor promedio reciente.
            */
            const recentAverageComparison =
                right.recentAverage - left.recentAverage;

            if (recentAverageComparison !== 0) {
                return recentAverageComparison;
            }

            /*
                Desempate final:
                nombre en orden alfabético.
            */
            return left.name.localeCompare(
                right.name,
                "es",
                {
                    sensitivity: "base"
                }
            );
        });
    },
    [
        positionFilter,
        rankingMode,
        state?.topPlayers
    ]
);

useEffect(
    function () {
        let cancelled = false;

        const playersToLoad = filteredPlayers.filter(
            function (player) {
                return !loadedTopPlayerImagesRef.current.has(
                    player.id
                );
            }
        );

        if (playersToLoad.length === 0) {
            return;
        }

        playersToLoad.forEach(function (player) {
            loadedTopPlayerImagesRef.current.add(player.id);
        });

        async function loadTopPlayerImages(): Promise<void> {
            try {
                const [
                    catalogPlayers,
                    teams
                ] = await Promise.all([
                    getPlayersList(),
                    getTeams()
                ]);

                const catalogById = new Map(
                    catalogPlayers.map(function (player) {
                        return [player.id, player];
                    })
                );

                const teamsById = new Map(
                    teams.map(function (team) {
                        return [team.id, team];
                    })
                );

                const images: Record<string, string> = {};
                const batchSize = 5;

                for (
                    let index = 0;
                    index < playersToLoad.length;
                    index += batchSize
                ) {
                    const batch = playersToLoad.slice(
                        index,
                        index + batchSize
                    );

                    const results = await Promise.all(
                        batch.map(async function (topPlayer) {
                            /*
                                DEF representa al equipo real.
                                Se utiliza el logo del equipo.
                            */
                            if (topPlayer.positionId === "8") {
                                const team = teamsById.get(
                                    topPlayer.teamId
                                ) as Team | undefined;

                                return {
                                    id: topPlayer.id,
                                    image: getPlayerImageUrl(
                                        team?.logo
                                    )
                                };
                            }

                            const catalogPlayer =
                                catalogById.get(topPlayer.id);

                            let image = getPlayerImageUrl(
                                catalogPlayer?.img
                            );

                            /*
                                Igual que FantasyPlayerModal:
                                se intenta usar la imagen de detalle,
                                que puede ser más reciente o completa.
                            */
                            try {
                                const detail =
                                    await getPlayerDetail(
                                        topPlayer.id
                                    );

                                const detailPlayer =
                                    detail.Info as PlayerModel;

                                image =
                                    getPlayerImageUrl(
                                        detailPlayer.img
                                    ) || image;
                            } catch {
                                /*
                                    Si falla el detalle se conserva
                                    la imagen disponible del catálogo.
                                */
                            }

                            return {
                                id: topPlayer.id,
                                image
                            };
                        })
                    );

                    results.forEach(function (result) {
                        images[result.id] = result.image;
                    });
                }

                if (!cancelled) {
                    setTopPlayerImages(function (currentImages) {
                        return {
                            ...currentImages,
                            ...images
                        };
                    });
                }
            } catch (requestError) {
                console.warn(
                    "No fue posible cargar imágenes de líderes:",
                    requestError
                );
            }
        }

        void loadTopPlayerImages();

        return function () {
            cancelled = true;
        };
    },
    [filteredPlayers]
);

const tradeCandidates = useMemo(
    function (): FantasyTradeCandidate[] {
        return (
            state?.roster.players || []
        ).map(function (player) {
            return {
                id: player.id,

                name: player.name,

                position:
                    player.position ||
                    getPositionLabel(player),

                realTeamName:
                    player.teamName ||
                    "Sin equipo",

                isLocked: Boolean(player.isLocked)
            };
        });
    },
    [state?.roster.players]
);
const myRosterPlayerIds = useMemo(
    function (): Set<string> {
        return new Set(
            (state?.roster.players || []).map(
                function (player) {
                    return player.id;
                }
            )
        );
    },
    [state?.roster.players]
);
const selectedTopPlayer = useMemo(
    function (): FantasyTopPlayer | null {
        if (!selectedPlayerId) {
            return null;
        }

        return (
            state?.topPlayers.find(
                function (player) {
                    return player.id === selectedPlayerId;
                }
            ) || null
        );
    },
    [selectedPlayerId, state?.topPlayers]
);
const isMyPlayer = Boolean(
    selectedTopPlayer &&
    myRosterPlayerIds.has(selectedTopPlayer.id)
);

const isFreeAgent = Boolean(
    selectedTopPlayer?.isAvailable
);

const belongsToAnotherTeam = Boolean(
    selectedTopPlayer &&
    !selectedTopPlayer.isAvailable &&
    !isMyPlayer
);

function handleAddFromTopPlayers(
    playerId: string
): void {
    if (!playerId) {
        setMessage(
            "No fue posible identificar al jugador para reclamar."
        );

        return;
    }

    /*
        No navegamos todavía. Primero cerramos FantasyPlayerModal
        para que Ionic retire correctamente su overlay y backdrop.
    */
    pendingClaimPlayerIdRef.current = playerId;

    setSelectedPlayerId(null);
}
const pendingDropPlayerIdRef = useRef("");

function handleDropFromTopPlayers(
    playerId: string
): void {
    if (!playerId) {
        return;
    }

    pendingDropPlayerIdRef.current = playerId;
    setSelectedPlayerId(null);
}

const activePlayersSubmenu = useMemo<
    "add" | "drop" | "leaders" | undefined
>(
    function () {
        if (
            location.pathname.startsWith(
                `/fantasyPlayers/${id}`
            )
        ) {
            return "add";
        }

        if (
            location.pathname.startsWith(
                `/fantasyDropPlayers/${id}`
            )
        ) {
            return "drop";
        }

        if (
            location.pathname.startsWith(
                `/fantasyTopPlayers/${id}`
            )
        ) {
            return "leaders";
        }

        /*
            Ya no estamos dentro de Jugadores.
            No debemos cambiar automáticamente a "add".
        */
        return undefined;
    },
    [id, location.pathname]
);

function goBackToPlayers(): void {
    router.push(
        `/fantasyPlayers/${id}`,
        "none"
    );
}

    return (
        <IonPage>
            <IonHeader>
<IonToolbar className="fantasy-top-toolbar">
<IonButtons slot="start">
<IonButton
    fill="clear"
    aria-label="Regresar a jugadores"
    onClick={goBackToPlayers}
>
    <IonIcon icon={arrowBackOutline} />
</IonButton>

</IonButtons>

    <IonTitle>Líderes</IonTitle>

    <FantasyHeaderActions
        leagueId={id || ""}
        screen="topPlayers"
        showSettings={false}
    />
</IonToolbar>


<IonToolbar className="fantasy-navigation-toolbar">
<IonSegment
    value={activeMainTab || ""}
    onIonChange={function (event) {
        const value = String(event.detail.value || "");

        if (!isFantasyMainTab(value)) {
            return;
        }

        navigateMainTab(value);
    }}
>
    <IonSegmentButton value="home">
        Inicio
    </IonSegmentButton>

    <IonSegmentButton value="players">
        Jugadores
    </IonSegmentButton>

    <IonSegmentButton value="team">
        Mi equipo
    </IonSegmentButton>

    <IonSegmentButton value="game">
        Juego
    </IonSegmentButton>
</IonSegment>
</IonToolbar>

{activeMainTab === "players" &&
    activePlayersSubmenu && (
        <IonToolbar className="fantasy-subnavigation-toolbar">
            <IonSegment
                value={activePlayersSubmenu}
                onIonChange={function (event) {
                    if (
                        activeMainTab !== "players" ||
                        !activePlayersSubmenu
                    ) {
                        return;
                    }

                    const selectedTab = String(
                        event.detail.value || ""
                    );

                    if (
                        selectedTab !== "add" &&
                        selectedTab !== "drop" &&
                        selectedTab !== "leaders"
                    ) {
                        return;
                    }

                    if (selectedTab === activePlayersSubmenu) {
                        return;
                    }

                    router.push(
                        getFantasyPlayersSubmenuPath(
                            selectedTab,
                            id
                        ),
                        "none",
                        "replace"
                    );
                }}
            >
                <IonSegmentButton value="add">
                    Agregar
                </IonSegmentButton>

                <IonSegmentButton value="drop">
                    Soltar
                </IonSegmentButton>

                <IonSegmentButton value="leaders">
                    Líderes
                </IonSegmentButton>
            </IonSegment>
        </IonToolbar>
    )}
            </IonHeader>

            <IonContent
                className="fantasy-top-content"
            >
                <IonRefresher
                    slot="fixed"
                    onIonRefresh={handleRefresh}
                >
                    <IonRefresherContent
                        pullingText="Desliza para actualizar"
                        refreshingText="Actualizando líderes..."
                    />
                </IonRefresher>

                {loading && (
                    <IonProgressBar
                        type="indeterminate"
                        className="fantasy-top-progress"
                    />
                )}

                {!loading && error && (
                    <main className="fantasy-top-main">
                        <div className="fantasy-top-empty">
                            <IonIcon icon={refreshOutline} />

                            <strong>
                                No pudimos cargar los líderes
                            </strong>

                            <span>{error}</span>

                            <IonButton
                                size="small"
                                fill="outline"
                                onClick={function () {
                                    loadTopPlayers(true);
                                }}
                            >
                                Reintentar
                            </IonButton>
                        </div>
                    </main>
                )}

                {!loading && !error && state && (
                    <><section className="fantasy-top-hero">
                        <div className="fantasy-top-hero__icon">
                            <IonIcon icon={trophyOutline} />
                        </div>

                        <div>
                            <span>{state.league.name}</span>
                            <h1>Líderes de la liga</h1>
                            <p>
                                Consulta a los jugadores con mejor rendimiento.
                            </p>
                        </div>
                    </section>
                    <main className="fantasy-top-main">

<section className="fantasy-top-ranking-mode">
    <div className="fantasy-top-ranking-mode__heading">
        <span>ORDENAR POR</span>
    </div>

    <IonSegment
        value={rankingMode}
        onIonChange={function (event) {
            const value = String(
                event.detail.value || "season"
            );

            if (
                value === "season" ||
                value === "week"
            ) {
                setRankingMode(value);
            }
        }}
    >
        <IonSegmentButton value="season">
            Temporada
        </IonSegmentButton>

        <IonSegmentButton value="week">
            Jornada
        </IonSegmentButton>
    </IonSegment>
</section>

                            <section className="fantasy-top-filter">
                                <IonSegment
                                    value={positionFilter}
                                    scrollable
                                    onIonChange={function (event) {
                                        setPositionFilter(
                                            String(
                                                event.detail.value ||
                                                "all"
                                            )
                                        );
                                    } }
                                >
                                    <IonSegmentButton value="all">
                                        Todos
                                    </IonSegmentButton>

                                    <IonSegmentButton value="QB">
                                        QB
                                    </IonSegmentButton>

                                    <IonSegmentButton value="RB">
                                        RB
                                    </IonSegmentButton>

                                    <IonSegmentButton value="WR">
                                        WR
                                    </IonSegmentButton>

                                    <IonSegmentButton value="K">
                                        K
                                    </IonSegmentButton>

                                    <IonSegmentButton value="DEF">
                                        DEF
                                    </IonSegmentButton>
                                </IonSegment>
                            </section>

                            <section className="fantasy-top-section">
                                <div className="fantasy-top-section__heading">
                                    <div>
                                        <span>CLASIFICACIÓN</span>

                                        <h2>
                                            {rankingMode === "season"
                                                ? positionFilter === "all"
                                                    ? "Líderes de la temporada"
                                                    : `Líderes de temporada · ${positionFilter}`
                                                : positionFilter === "all"
                                                    ? `Líderes de la jornada ${state.week.realRound}`
                                                    : `Jornada ${state.week.realRound} · ${positionFilter}`}
                                        </h2>

                                    </div>

                                    {refreshing && (
                                        <IonSpinner name="crescent" />
                                    )}
                                </div>

                                {filteredPlayers.length === 0 ? (
                                    <div className="fantasy-top-empty">
                                        <IonIcon
                                            icon={americanFootballOutline} />

                                        <strong>
                                            No hay jugadores para mostrar
                                        </strong>

                                        <span>
                                            No existen registros para
                                            este filtro.
                                        </span>
                                    </div>
                                ) : (
                                    <div className="fantasy-top-list">
                                        {filteredPlayers.map(
                                            function (
                                                player,
                                                index
                                            ) {
                                                const position = getPositionLabel(
                                                    player
                                                );

                                                const image = topPlayerImages[player.id] || "";

                                                return (
                                                    <article
    key={player.id}
    role="button"
    tabIndex={0}
    className="fantasy-top-card fantasy-top-card--selectable"
    onClick={function () {
        setSelectedPlayerId(player.id);
    }}
    onKeyDown={function (event) {
        if (
            event.key === "Enter" ||
            event.key === " "
        ) {
            event.preventDefault();

            setSelectedPlayerId(player.id);
        }
    }}
>

                                                        <div className="fantasy-top-card__rank">
                                                            #{index + 1}
                                                        </div>

                                                        <div
                                                            className={[
                                                                "fantasy-top-card__avatar",
                                                                `fantasy-top-card__avatar--${position.toLowerCase()}`,
                                                                image
                                                                    ? "fantasy-top-card__avatar--has-image"
                                                                    : ""
                                                            ].join(" ")}
                                                        >

                                                            {image ? (
                                                                <img
                                                                    src={image}
                                                                    alt={`Foto de ${player.name}`}
                                                                    loading="lazy"
                                                                />
                                                            ) : (
                                                                <span aria-label={`Sin imagen de ${player.name}`}>
                                                                    {getPlayerInitial(player.name)}
                                                                </span>
                                                            )}
                                                        </div>

                                                        <div className="fantasy-top-card__details">
                                                            <strong>
                                                                {player.name}
                                                            </strong>

                                                            <small className="fantasy-top-card__team">
                                                                <b
                                                                    className={`fantasy-top-card__team-position fantasy-top-card__team-position--${position.toLowerCase()}`}
                                                                >
                                                                    {position}
                                                                </b>

                                                                <span aria-hidden="true"> · </span>

                                                                {player.teamName || "Sin equipo"}
                                                            </small>

                                                            <div className="fantasy-top-card__status">
                                                                {player.isAvailable ? (
                                                                    <>
                                                                        <IonIcon
                                                                            icon={checkmarkCircleOutline} />

                                                                        Disponible
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <IonIcon
                                                                            icon={peopleOutline} />
{player.ownerName || "En roster"}
                                                                        
                                                                    </>
                                                                )}

                                                                {player.isLocked && (
                                                                    <>
                                                                        <span>
                                                                            ·
                                                                        </span>

                                                                        <IonIcon
                                                                            icon={lockClosedOutline} />

                                                                        Bloqueado
                                                                    </>
                                                                )}
                                                            </div>
                                                        </div>

                                                        <div className="fantasy-top-card__stats">
                                                            <div>
                                                                <span>
                                                                    {rankingMode === "season"
                                                                        ? "PTS"
                                                                        : "PTS JOR."}
                                                                </span>

                                                                <strong>
                                                                    {formatPoints(
                                                                        rankingMode === "season"
                                                                            ? player.seasonPoints
                                                                            : player.weekPoints
                                                                    )}
                                                                </strong>
                                                            </div>


                                                            <div>
                                                                <span>
                                                                    PROM.
                                                                </span>

                                                                <strong>
                                                                    {formatPoints(
                                                                        player.recentAverage
                                                                    )}
                                                                </strong>
                                                            </div>

                                                            <div>
                                                                <span>
                                                                    PROY.
                                                                </span>

                                                                <strong>
                                                                    {formatPoints(
                                                                        player.weekProjection
                                                                    )}
                                                                </strong>
                                                            </div>
                                                        </div>
                                                    </article>
                                                );
                                            }
                                        )}
                                    </div>
                                )}
                            </section>
                        </main></>
                )}
            </IonContent>
<FantasyPlayerModal
    leagueId={id || ""}
    playerId={selectedPlayerId || ""}
    isOpen={selectedPlayerId !== null}
    onDismiss={handlePlayerModalDismiss}
    onRequestTrade={handleRequestTrade}
    onClaimPlayer={handleAddFromTopPlayers}
    onDropPlayer={handleDropFromTopPlayers}
/>

<FantasyTradeOfferModal
    isOpen={isTradeOfferOpen}
    requestedPlayer={tradeRequestedPlayer}
    candidates={tradeCandidates}
    isSubmitting={isSubmittingTrade}
    onDismiss={function () {
        if (isSubmittingTrade) {
            return;
        }

        setIsTradeOfferOpen(false);
        setTradeRequestedPlayer(null);
    }}
    onSubmit={createTrade}
/>

<IonToast
    isOpen={Boolean(message)}
    message={message}
    duration={3400}
    position="bottom"
    onDidDismiss={function () {
        setMessage("");
    }}
/>


        </IonPage>
    );
};

export default FantasyTopPlayers;
